import React from 'react';
import { ResponsiveBar } from '@nivo/bar';
import { useSelector } from 'react-redux';
import { SystemText } from 'e4shared';

const Chart = ({ data, item }) => {
    const { user } = useSelector(state => state.user);
    const ratingRange = user.companySettings?.display?.ratingRange || 5;
    const reviewTypes = useSelector(state => state.user.user.reviewTypes) || [];
    const hasManager = reviewTypes.some(x => x.indexOf('M') >= 0);

    const text = {
        staff: SystemText('Dashboard/Widgets/TeamRatings/Staff'),
        manager: SystemText('Dashboard/Widgets/TeamRatings/Manager'),
        actual: SystemText('Dashboard/Widgets/TeamRatings/Actual'),
        team: SystemText('Dashboard/Widgets/TeamRatings/Team'),
        rating: SystemText('Dashboard/Widgets/TeamRatings/Rating'),
    };

    return (
        <ResponsiveBar
            data={data}
            keys={!hasManager ? [text.staff] : [text.staff, text.manager, text.actual]}
            indexBy="id"
            margin={{ top: 10, right: 130, bottom: 50, left: 60 }}
            padding={0.2}
            innerPadding={2}
            groupMode="grouped"
            valueScale={{ type: 'linear' }}
            indexScale={{ type: 'band', round: true }}
            valueFormat={{ format: ' >-', enabled: false }}
            colors={{ scheme: 'nivo' }}
            minValue={0}
            maxValue={ratingRange}
            borderRadius={2}
            borderWidth={1}
            borderColor={{ from: 'color', modifiers: [['darker', '0.5']] }}
            axisTop={null}
            axisRight={null}
            axisBottom={{
                tickSize: 5,
                tickPadding: 5,
                tickRotation: 0,
                legend: text.team,
                legendPosition: 'middle',
                legendOffset: 40,
            }}
            axisLeft={{
                tickValues: item.h > 2 ? [0, 0.5, 1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5] : [0, 1, 2, 3, 4, 5],
                tickSize: 5,
                tickPadding: 5,
                tickRotation: 0,
                legend: text.rating,
                legendPosition: 'middle',
                legendOffset: -40,
            }}
            enableLabel={false}
            labelTextColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
            legends={[
                {
                    dataFrom: 'keys',
                    anchor: 'bottom-right',
                    direction: 'column',
                    justify: false,
                    translateX: 120,
                    translateY: 0,
                    itemsSpacing: 2,
                    itemWidth: 100,
                    itemHeight: 20,
                    itemDirection: 'left-to-right',
                    itemOpacity: 0.85,
                    symbolSize: 20,
                    effects: [
                        {
                            on: 'hover',
                            style: {
                                itemOpacity: 1,
                            },
                        },
                    ],
                },
            ]}
        />
    );
};

export default Chart;
